import "./App.css";
import React, { Suspense, lazy, useState } from "react";
import { ConfigProvider } from "antd";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { store } from "./store";

import { Provider } from "react-redux";
import setAuthToken from "./utils/setAuthToken";
import AdminRoute from "./routes/AdminRoute";
import Sidebar from "./layout/Sidebar";
import Navbar from "./layout/Navbar";
import { saveConfig, saveProfile, setAdmin } from "./actions/AuthAction";
import { setConfig } from "./reducers/configReducer";
import { isPermitted } from "./utils/PermissionManager";
import { setProfile } from "./reducers/authReducer";
import Bottombar from "./layout/BottomBar";
import { siteInfo } from "./utils/SiteInfo";
import LoginFailed from "./pages/LoginFailed";
import ChatStart from "./components/common/ChatStart";
const ChatChina = lazy(() => import("./pages/ChatChina"));
const CrmLeaderTarget = lazy(() => import("./pages/crm/CrmLeaderTarget"));
const SeaOrderConfirm = lazy(() => import("./pages/SeaOrderConfirm"));
const SlabControl = lazy(() => import("./pages/crm/SlabControl"));
const QcCustomer = lazy(() => import("./pages/QcCustomer"));
const CRMCustomer = lazy(() => import("./pages/crm/CRMCustomer"));
const CrmManagers = lazy(() => import("./pages/crm/CrmManagers"));
const MyCrm = lazy(() => import("./pages/crm/MyCrm"));
const CrmTargetFullfil = lazy(() => import("./pages/crm/CrmTargetFullfil"));
const QcAcknowledgement = lazy(() => import("./pages/QcAcknowledgement"));
const ManageTicket = lazy(() => import("./pages/ManageTicket"));

const Calls = lazy(() => import("./pages/Calls"));
const Support = lazy(() => import("./pages/Support"));
const Invoice = lazy(() => import("./pages/Invoice"));
const Customers = lazy(() => import("./pages/Customers"));
const Login = lazy(() => import("./pages/Login"));
const ManageOrder = lazy(() => import("./pages/ManageOrder"));
const Profile = lazy(() => import("./pages/Profile"));
const ComingSoon = lazy(() => import("./pages/ComingSoon"));
const Chatrooms = lazy(() => import("./pages/Chat"));
const HotlineCustomers = lazy(() => import("./pages/HotlineCustomers"));
const HotlineOrders = lazy(() => import("./pages/HotlineOrders"));

if (localStorage.config) {
  let config = JSON.parse(localStorage.config);
  let profile = config.profile;
  store.dispatch(setProfile(profile));
  store.dispatch(setConfig(config));
}

if (localStorage.skyadmin) {
  setAuthToken(localStorage.skyadmin);
  store.dispatch(setAdmin(true));
  store.dispatch(saveConfig());
  store.dispatch(saveProfile());
}

const DashboardNew = lazy(() => import("./pages/DashboardNew"));

function App() {
  const client = window.screen.width > 768 ? "web" : "app";
  const [show, setshow] = useState(client === "web" ? false : true);
  const [trigger, settrigger] = useState(false);

  const id = store.getState().auth?.profile?._id;
  const host = window.location.host;

  if (host !== "crm.skybuybd.com" && host !== "localhost:3000") {
    return (
      <div
        className="flex align-center justify-center flexColumn"
        style={{ height: "100vh", width: "100%", background: "#fff" }}
      >
        <img src={require("./assets/locked.png")} style={{ width: 220 }} />
        <h2 className="mt1">Site Locked</h2>
        <p>This website is locked please contact authorized person.</p>
      </div>
    );
  }

  const roles = store.getState().auth?.profile?.roles
    ? store.getState().auth?.profile?.roles
    : [];

  const currentProfile = store.getState().auth?.profile;


  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: siteInfo.navColor,
            borderRadius: 8,
          },
        }}
      >
        <BrowserRouter>
          <ChatStart />
          <Suspense fallback={<div className="pageProgress"></div>}>
            <div className="App">
              <Sidebar state={{ show, setshow }} />
              <div>
                <Navbar state={{ settrigger, setshow, show }} />
                {roles?.length > 0 && <Bottombar />}
                <Routes>
                  <Route
                    exact
                    path="/"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<DashboardNew />}
                      />
                    }
                  />

                  {/* {isPermitted(roles, [
                    "admin",
                    "bn_purchase",
                    "cn_purchase",
                    "delivery",
                  ]) && (
                    <Route
                      exact
                      path="/customers"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Customers />}
                        />
                      }
                    />
                  )} */}

                  {/* <Route
                    exact
                    path="/order/:id"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<ManageOrder />}
                      />
                    }
                  />

                  {isPermitted(roles, [
                    "super_admin",
                    "admin",
                    "support",
                    "crm",
                  ]) && (
                    <Route
                      exact
                      path="/support/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<ManageTicket />}
                        />
                      }
                    />
                  )}
                  <Route
                    exact
                    path="/calls"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<Calls />}
                      />
                    }
                  /> */}

                  {/* {isPermitted(roles, ["admin", "delivery", "crm"]) && (
                    <Route
                      exact
                      path="/invoice/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Invoice />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                    <Route
                      exact
                      path="/qc"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<QcAcknowledgement />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, [
                    "admin",
                    "bd_purchase",
                    "cn_purchase",
                  ]) && (
                    <Route
                      exact
                      path="/qc-customer"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<QcCustomer />}
                        />
                      }
                    />
                  )}

                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/sea-orders"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<SeaOrderConfirm />}
                        />
                      }
                    />
                  )} */}

                  {isPermitted(roles, ["admin", "crm"]) && (
                    <Route
                      exact
                      path="/invoice/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Invoice />}
                        />
                      }
                    />
                  )}

                  <Route
                    exact
                    path="/order/:id"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<ManageOrder />}
                      />
                    }
                  />

                  {isPermitted(roles, [
                    "super_admin",
                    "admin",
                    "support",
                    "crm",
                  ]) && (
                      <Route
                        exact
                        path="/support/:id"
                        element={
                          <AdminRoute
                            state={{ show, trigger }}
                            component={<ManageTicket />}
                          />
                        }
                      />
                    )}

                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/managers"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CrmManagers />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "crm_team_leader"]) && (
                    <Route
                      exact
                      path="/manager-targets"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CrmTargetFullfil />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/leader-targets"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CrmLeaderTarget />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin"]) && (
                    <Route
                      exact
                      path="/slab-control"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<SlabControl />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "crm"]) && (
                    <Route
                      exact
                      path="/sky-crm/:id?"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<MyCrm />}
                        />
                      }
                    />
                  )}
                  {isPermitted(roles, ["admin", "crm"]) && (
                    <Route
                      exact
                      path="/crm/customer/:id"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<CRMCustomer />}
                        />
                      }
                    />
                  )}

                  {/* {isPermitted(roles, ["admin", "support"]) && (
                    <Route
                      exact
                      path="/support"
                      element={
                        <AdminRoute
                          state={{ show, trigger }}
                          component={<Support />}
                        />
                      }
                    />
                  )} */}

                  <Route
                    exact
                    path="/profile"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<Profile />}
                      />
                    }
                  />

                  <Route
                    exact
                    path="/chat/:order?"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<Chatrooms />}
                      />
                    }
                  />

                  <Route
                    exact
                    path="/chat-china/:order?"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<ChatChina />}
                      />
                    }
                  />

                  {(currentProfile?.crm?.manager_type === 0 || isPermitted(roles, ["admin"])) && <Route
                    exact
                    path="/hotline-customers"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<HotlineCustomers />}
                      />
                    }
                  />}

                  {(currentProfile?.crm?.manager_type === 0 || isPermitted(roles, ["admin"])) && <Route
                    exact
                    path="/hotline-orders"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={<HotlineOrders />}
                      />
                    }
                  />}

                  <Route exact path="/login" element={<Login />} />
                  <Route exact path="/unauthorized" element={<LoginFailed />} />
                  <Route
                    path="*"
                    element={
                      <AdminRoute
                        state={{ show, trigger }}
                        component={
                          <div
                            style={{
                              height: "calc(100vh - 78px)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#fff",
                            }}
                          >
                            <ComingSoon />
                          </div>
                        }
                      />
                    }
                  />
                </Routes>
              </div>
            </div>
          </Suspense>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
